import _toString from "../internals/to-string";
var exports = {};
var toString = _toString;
exports = function (argument, $default) {
  return argument === undefined ? arguments.length < 2 ? "" : $default : toString(argument);
};
export default exports;